import React from 'react'
import styles from "../../styles/screens/PrasadBox/PBContent.module.css"
import DecorateFlower from "../../assets/prasad_gift/DecorateFlower.png"

import Ayodhya1 from '../../assets/prasad_gift/ayodhya1.png'
import Ayodhya2 from '../../assets/prasad_gift/ayodhya2.png'
import Ayodhya3 from '../../assets/prasad_gift/ayodhya3.png'
import Ayodhya4 from '../../assets/prasad_gift/ayodhya4.png'
import Ayodhya5 from '../../assets/prasad_gift/ayodhya5.png'
import Ayodhya6 from '../../assets/prasad_gift/ayodhya6.png'
import Ayodhya7 from '../../assets/prasad_gift/ayodhya7.png'
import Ayodhya8 from '../../assets/prasad_gift/ayodhya8.png'

import Vrindavan1 from '../../assets/holiprasad/1-removebg-preview.png'
import Vrindavan2 from '../../assets/holiprasad/2-removebg-preview.png'
import Vrindavan3 from '../../assets/holiprasad/3-removebg-previe.png'
import Vrindavan4 from '../../assets/holiprasad/4-removebg-previe.png'
import Vrindavan5 from '../../assets/holiprasad/5-removebg-previe.png'
import Vrindavan6 from '../../assets/holiprasad/6-removebg-previe.png'
import Vrindavan7 from '../../assets/holiprasad/7-removebg-previe.png'
import Vrindavan8 from '../../assets/holiprasad/8-removebg-preview.png'
import Vrindavan9 from '../../assets/holiprasad/9-removebg-previe.png'
import Vrindavan10 from '../../assets/holiprasad/10-removebg-preview.png'

const PBContent = ({ productId }) => {
  const ayodhyaItems = [
    { id: 1, image: Ayodhya1, alt: "Ramji prasad" },
    { id: 2, image: Ayodhya2, alt: "Hanumanji prasad" },
    { id: 3, image: Ayodhya3, alt: "Ramji darbar" },
    { id: 4, image: Ayodhya4, alt: "Hanumanji sindoor" },
    { id: 5, image: Ayodhya5, alt: "Rakshasutra" },
    { id: 6, image: Ayodhya6, alt: "Ayodhya prasad item" },
    { id: 7, image: Ayodhya7, alt: "Ayodhya prasad item" },
    { id: 8, image: Ayodhya8, alt: "Ayodhya prasad item" },
  ];

  const vrindavanItems = [
    { id: 1, image: Vrindavan1, alt: "Krishna prasad" },
    { id: 2, image: Vrindavan2, alt: "Radha prasad" },
    { id: 3, image: Vrindavan3, alt: "Krishna darbar" },
    { id: 4, image: Vrindavan4, alt: "Vrindavan chandan" },
    { id: 5, image: Vrindavan5, alt: "Vrindavan mala" },
    { id: 6, image: Vrindavan6, alt: "Vrindavan prasad item" },
    { id: 7, image: Vrindavan7, alt: "Vrindavan prasad item" },
    { id: 8, image: Vrindavan8, alt: "Vrindavan prasad item" },
    { id: 9, image: Vrindavan9, alt: "Vrindavan prasad item" },
    { id: 10, image: Vrindavan10, alt: "Vrindavan prasad item" },
  ];

  const items = productId === "ayodhya-prasad-box" ? ayodhyaItems : vrindavanItems;

  return (
    <div className={styles.contentsContainer}>
      <div className={styles.backgroundDecoration}>
        <img
          src={DecorateFlower}
          alt="Decorative mandala background"
          fill
          className={styles.mandalaImage}
        />
      </div>

      <h1 className={styles.mainTitle}>
        {productId === "ayodhya-prasad-box" ? "Ayodhya Prasad Box" : "Vrindavan Prasad Box"}
      </h1>
      <div className={styles.titleUnderline}></div>

      <p className={styles.description}>
        {productId === "ayodhya-prasad-box" ? (
          <>
            Blessed Ramji prasad, Hanumanji prasad from Hanuman Garhi, Ramji darbar, Hanumanji sindoor,
            <br />
            rakshasutra and more blessed items sourced directly from Ayodhya.
          </>
        ) : (
          <>
            Blessed Krishna prasad, Radha prasad, Krishna darbar, Vrindavan chandan,
            <br />
            sacred mala and more blessed items sourced directly from Vrindavan.
          </>
        )}
      </p>

      <p className={styles.includedText}>(What all is included ?)</p>

      <div className={styles.itemsGrid}>
        {items.map((item) => (
          <div
            key={item.id}
            className={styles.itemContainer}
          >
            <img
              src={item.image}
              alt={item.alt}
              className={styles.itemImage}
            />
          </div>
        ))}
      </div>
</div>

  )
}

export default PBContent
